<template>
  <b-modal
    :id="id"
    cancel-title="Annulla"
    cancel-variant="outline-secondary"
    centered
    ok-title="Elimina"
    title="Cancella Elemento"
    @ok="_delete"
  >
    <b-form>
      <b-form-group>
        <template v-if="permanent">
          <label
            style="font-size: large"
            for="name"
          >
            Sicuro di voler eliminare <b>definitivamente</b> questi file?
          </label>
          <p class="mb-0 mt-1">
            L'operazione è irreversibile: gli elementi non saranno più recuperabili.
          </p>
        </template>
        <template v-else>
          <label
            style="font-size: large"
            for="name"
          >Sicuro di voler eliminare <i>{{ label ? label : '' }}</i>?</label>
          <p class="mb-0 mt-1">
            {{ retentionNotice }}
          </p>
        </template>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup,
} from 'bootstrap-vue'
import objectsRepository from '@/api/objectsRepository'
import useMyStore from '@/services/useMyStore'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'Modal',
  components: {
    BModal,
    BForm,
    BFormGroup,
  },
  props: {
    files: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedFiles: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: () => false,
    },
    id: {
      type: String,
      default: () => 'remove-modal',
    },
    permanent: {
      type: Boolean,
      default: () => false,
    },
  },
  setup() {
    const { currentObject } = useMyStore()
    return { currentObject }
  },
  data() {
    return {
    }
  },
  computed: {
    label() {
      if (this.permanent) return ''
      if (this.selectedFiles.length > 0) {
        return `${this.selectedFiles.length} files`
      }
      const file = this.files.find(el => el.id === this.currentObject)
      if (file) return file.label
      return ''
    },
    selected_ids() {
      if (this.selectedFiles.find(el => el.id === this.currentObject) || this.multiple) {
        return this.commonHelpers.pluck(this.selectedFiles, 'id')
      }
      return [this.currentObject]
    },
    retentionNotice() {
      if (this.selected_ids.length > 1) {
        return 'Resteranno nel cestino e saranno recuperabili per 5 anni.'
      }
      return 'Resterà nel cestino e sarà recuperabile per 5 anni.'
    },
  },
  methods: {
    // eslint-disable-next-line no-underscore-dangle
    async _delete() {
      this.$emit('loading', true)
      try {
        const response = await objectsRepository.multipleDelete({ ids: this.selected_ids, permanent: this.permanent })
        const { data } = response
        if (data.code) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.permanent ? 'Successo! File(s) eliminato/i definitivamente.' : 'Successo! File(s) eliminato/i.',
              text: this.permanent ? '' : 'Recuperabile/i dal cestino per 5 anni.',
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          {
            position: 'top-right',
          })
          this.$emit('removed')
          this.$emit('reloadDirs')
        } else {
          this.apiErrors.notifyApiError(response)
          this.$emit('loading', false)
        }
      } catch (e) {
        this.apiErrors.notifyApiError(e)
        this.$emit('loading', false)
      }
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style>
[dir="ltr"] .modal-header .close {
  margin: -0.5rem -0.6rem -0.5rem auto;
}
</style>
